import { render } from "./OffcanvasBody.vue?vue&type=template&id=ea994caa"
import script from "./OffcanvasBody.vue?vue&type=script&lang=js"
export * from "./OffcanvasBody.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__